<template>
  <div class="client-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Lista de transações</span>
          </b-col>
<!--          <b-col cols="12" md="6">-->
<!--            <b-row class="d-flex align-items-center justify-content-end" >-->
<!--              <b-col cols="auto">-->
<!--                <b-form-input type="text" :placeholder="'Nome do cliente'" v-model="searchBy"></b-form-input>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <div class="mb-4">
<!--          <b-row class="mb-2">-->
<!--            <b-col>-->
<!--              <label class="cj-label">Período</label>-->
<!--              <date-range-picker-->
<!--                  class="w-100"-->
<!--                  ref="picker"-->
<!--                  :localeData="dateRangePickerPtBrLocale"-->
<!--                  :timePicker="false"-->
<!--                  :timePicker24Hour="false"-->
<!--                  :showDropdowns="true"-->
<!--                  :ranges="false"-->
<!--                  :showWeekNumbers="false"-->
<!--                  :opens="'right'"-->
<!--                  v-model="transactionFilterForm.dateTime">-->
<!--                <div slot="input" slot-scope="picker" class="">-->
<!--                  {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}-->
<!--                </div>-->
<!--              </date-range-picker>-->
<!--            </b-col>-->
<!--          </b-row>-->
          <b-row>
            <b-col>
              <label class="cj-label">Buscar</label>
              <b-form-input type="text" v-model="searchBy" @keyup.enter="getTransactions(1)"></b-form-input>
            </b-col>
<!--            <b-col>-->
<!--              <label class="cj-label">Categoria</label>-->
<!--              <multiselect v-model="transactionFilterForm.category" :options="categories" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">-->
<!--                <template slot="clear">-->
<!--                  <div class="multiselect__clear" v-if="transactionFilterForm.category != null" @mousedown.prevent.stop="transactionFilterForm.category = null" @click="alert('ata')"></div>-->
<!--                </template>-->
<!--              </multiselect>-->
<!--            </b-col>-->
            <b-col>
              <label class="cj-label">Método de pagamento</label>
              <multiselect v-model="paymentMethod" :options="paymentMethodOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="paymentMethod != ''" @mousedown.prevent.stop="paymentMethod = ''"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label">Status</label>
              <multiselect v-model="status" :options="invoiceStatusOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="status != ''" @mousedown.prevent.stop="status = ''"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label">Status NFSe</label>
              <multiselect v-model="nfseStatus" :options="nfseStatusOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="nfseStatus != ''" @mousedown.prevent.stop="nfseStatus = ''"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label w-100">&nbsp;</label>
              <b-button variant="primary" block @click="getTransactions(1)"><i class="far fa-search"></i> Filtrar</b-button>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Lista de transações</p>
                  <p class="title"><small>{{ pagination.total }} transações cadastradas</small></p>
                </div>
              </div>
              <div class="content">

                <div v-if="pagination.lastPage > 1">
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getTransactions"></b-pagination>
                  <hr>
                </div>

                <table class="table table-responsive w-100 d-block d-md-table">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Cliente</th>
                      <th>Método de pagamento</th>
                      <th>Valor</th>
                      <th>Identificador</th>
                      <th>Status</th>
                      <th>Nº da NFSe</th>
                      <th>Status NFSe</th>
                      <th>Ações NFSe</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="invoice in invoices" :key="invoice.id">
                      <td>{{ moment(invoice.date).format('DD/MM/YYYY') }}</td>
                      <router-link tag="td" :to="'/clientes/'+invoice.client_id">{{ invoice.client }}</router-link>
                      <td>{{ invoice.payment_method == 'boleto' ? 'Boleto' : (invoice.payment_method == 'pix' ? 'Pix' : (invoice.card_brand + ' ' + invoice.card_bin + ' ****')) }}</td>
                      <td>R$ {{ formatPrice(invoice.value_in_cents/100.0) }}</td>
                      <td>{{ invoice.payment_method == 'boleto' ? invoice.boleto_document_number : (invoice.payment_method == 'pix' ? invoice.pix_id : (invoice.card_nsu != null ? (invoice.card_nsu + '-' + invoice.card_auth) : '')) }}</td>
                      <td>{{ invoiceStatusOptions.find(g => g.value == invoice.status).name }}</td>
                      <td>{{ invoice.nfse_number }}</td>
                      <td>{{ (invoice.nfse_status != null ? nfseStatusOptions.find(g => g.value == invoice.nfse_status).name : '') + (invoice.nfse_error != null ? (' - ' + invoice.nfse_error) : '') }}</td>
                      <td>
                        <b-button v-if="invoice.nfse_status != null && (invoice.nfse_status == 'CANCELADO' || invoice.nfse_status == 'CONCLUIDO')" variant="primary" size="sm" block @click="downloadNfse(invoice.id, invoice.nfse_number)"><i class="far fa-download"></i></b-button>
                        <b-button v-else-if="invoice.status == 'succeeded' && (invoice.nfse_status == null || invoice.nfse_status == 'REJEITADO')" variant="primary" size="sm" block @click="issueInvoiceNfse(invoice.id)">Emitir</b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p v-if="searchBy == '' && paymentMethod == '' && status == '' && nfseStatus == '' && invoices.length == 0" class="text-center sub-title">Você ainda não possui nenhuma transação cadastrada.</p>
                <p v-if="(searchBy != '' || paymentMethod != '' || status != '' || nfseStatus != '') && invoices.length == 0" class="text-center sub-title">A sua busca por transações não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getTransactions"></b-pagination>
                </div>

              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        url: '',
        newTerm: '',
        module: '',

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        canSee: true,
        canEdit: true,

        invoices: [],

        paymentMethodOptions: [
          { value: 'boleto', name: 'Boleto' },
          { value: 'pix', name: 'Pix' },
          { value: 'credit', name: 'Crédito' }
        ],

        invoiceStatusOptions: [
          { value: 'new', name: 'Novo' },
          { value: 'pending', name: 'Pendente' },
          { value: 'pre_authorized', name: 'Pré-autorizado' },
          { value: 'succeeded', name: 'Pago' },
          { value: 'failed', name: 'Recusado' },
          { value: 'reversed', name: 'Revertido' },
          { value: 'canceled', name: 'Cancelado' },
          { value: 'refunded', name: 'Reembolsado' },
          { value: 'dispute', name: 'Em disputa' },
          { value: 'charged_back', name: 'Devolvido' }
        ],

        nfseStatusOptions: [
          { value: 'PROCESSANDO', name: 'Processando' },
          { value: 'CANCELADO', name: 'Cancelada' },
          { value: 'CONCLUIDO', name: 'Emitida' },
          { value: 'DENEGADO', name: 'Denegada' },
          { value: 'REJEITADO', name: 'Rejeitada' }
        ],

        searchBy: '',
        paymentMethod: '',
        status: '',
        nfseStatus: ''
      }
    },
    mounted () {
      this.eventBus.$emit('IS_LOADING', true);

      this.url = 'transacoes';
      this.newTerm = 'cadastrar-transacao';
      this.module = 'transactions';

      this.canSee = true;
      this.canEdit = true;

      this.getTransactions(this.pagination.currentPage);
    },
    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      getTransactions(page) {
        let transactionsData = {
          name: this.searchBy,
          payment_method: (this.paymentMethod != null)?this.paymentMethod.value:null,
          status: (this.status != null)?this.status.value:null,
          nfse_status: (this.nfseStatus != null)?this.nfseStatus.value:null,
          page: page
        };
        this.api.getTransactions(transactionsData).then(res => {
          this.invoices = res.data.data;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;

          this.eventBus.$emit('IS_LOADING', false);

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Transactions', res);
        }).catch(err => {
          this.$swal('Ops...', 'Não conseguimos carregar as transações! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Transactions', err.response);
        });
      },

      async issueInvoiceNfse(invoiceId) {
        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);
        this.api.issueInvoiceNfse(invoiceId).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let invoice = this.invoices.find(g => g.id == invoiceId),
            invoiceIndex = this.invoices.indexOf(invoice);
          this.invoices.splice(invoiceIndex, 1, res.data)

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Issue Nfse', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let response = err.response;
          if(response.status == 401) {
            this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
              this.$router.push({ path: '/' });
            });
          }
          else {
            let message = 'Não conseguimos baixar a nota fiscal! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
            switch (response.status) {
              case 422: message = response.data.errors.join('\r\n'); break;
              case 400: message = typeof response.data.message != 'undefined' && response.data.message != '' ? response.data.message : message; break;
            }

            this.$swal('Ops...', message, 'error');
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Issue Nfse', err);
        });
      },

      async downloadNfse(invoiceId, nfseNumber) {
        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);
        this.api.getInvoiceNfse(invoiceId).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.downloadFile(res.data, 'nfse_' + nfseNumber + '.pdf')


          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Download Nfse', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          let response = err.response;
          if(response.status == 401) {
            this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
              this.$router.push({ path: '/' });
            });
          }
          else {
            let message = 'Não conseguimos baixar a nota fiscal! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
            switch (response.status) {
              case 422: message = response.data.errors.join('\r\n'); break;
              case 400: message = typeof response.data.message != 'undefined' && response.data.message != '' ? response.data.message : message; break;
            }

            this.$swal('Ops...', message, 'error');
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Download Nfse', err);
        });
      },

      downloadFile(fileData, fileName) {
        var blob = new Blob([fileData], {type: 'application/pdf'});

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
          return;
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = data;
        link.download = fileName;
        link.click();
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
        }, 100);
      }
    }
  }
</script>

<style lang="scss">
  .main-content-cj {
    &.client-list {
      padding: 20px 0;

      .box-cj {
        .content {
          th {
            font-size: 14px;
            color: $cadetGray;
            border-top: 0;
          }

          tbody {
            font-size: 14px;
            color: $waikawaGray;

            .line-add {
              padding: 10px 0;
            }

            tr:nth-child(even) {
              background-color: $whisper;
            }

            tr:nth-child(odd) {
            }

            .situation-indicator {
              font-size: 12px;

              &.using {
                color: $ufoGreen;
              }
              &.stopped-using {
                color: $yellowSea;
              }
              &.not-using-anymore {
                color: $dullRed;
              }
              &.never-used {
                color: #333333;
              }
            }
          }
        }
      }
    }
  }
</style>
